export default "/images/vendor/geoportal-extensions-openlayers/src/OpenLayers/CSS/Controls/LayerSwitcher/GPlayerInfoClose.png?c2c48906f6e50c6c8038cf49bc290a3f";